import { render } from "./Psychiatry.vue?vue&type=template&id=5c399401"
import script from "./Psychiatry.vue?vue&type=script&lang=ts"
export * from "./Psychiatry.vue?vue&type=script&lang=ts"
script.render = render

export default script